import { Injectable, inject } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Cart, CheckoutStep, DeliveryModeType } from '@boels/models';
import { CartFacade } from '@boels/shared-state';
import { checkoutSteps, deliveryCheckoutSteps } from './checkout-step.config';
import { RoutingService } from '@boels/helpers';

export const CHECKOUT_STEP = 'checkoutStep';

@Injectable({
  providedIn: 'root',
})
export class CheckoutStepService {
  private routingService = inject(RoutingService);
  private cartFacade = inject(CartFacade);

  getCheckoutSteps(): Observable<CheckoutStep[]> {
    const checkoutStepParam = this.routingService.getRouteProperty('params')?.[
      CHECKOUT_STEP
    ] as string;
    return this.cartFacade.getActiveCart().pipe(
      filter(Boolean),
      map((cart: Cart) => {
        return checkoutSteps.map((checkoutStep: CheckoutStep) => {
          let result: CheckoutStep = checkoutStep;
          if (checkoutStep.step === 3 && cart.deliveryMode) {
            result =
              cart.deliveryMode.code === DeliveryModeType.DELIVERY
                ? deliveryCheckoutSteps[0]
                : deliveryCheckoutSteps[1];
          }
          if (result.urlParam === checkoutStepParam) {
            this.cartFacade.setActiveStepNumber(result.step);
          }
          return result;
        });
      }),
    );
  }
}
